<template>
  <div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 text-muted">RATING ENGINE / INSURERS</h1>
      <button
        type="button"
        class="btn btn-primary"
        @click="$router.push('/addInsurer')"
        id="but"
      >
        Add Insurer
      </button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">#ID</th>
          <th scope="col">Insurer Name</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="insurer in insurers"
          :key="insurer.InsurerId"
          @click="edit(insurer.insurer_id)"
          class="clickable-row"
        >
          <td>{{ insurer.insurer_id }}</td>
          <td
            style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 5%;"
          >
            {{ insurer.insurer_name }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import config from "../../config";
export default {
  data() {
    return {
      insurers: [],
    };
  },
  methods: {
    edit(id) {
      this.$router.push("/editinsurer/" + id);
    },
  },
  async mounted() {
    const res = await fetch(config.baseURL + "/get_insurers", {
      credentials: "include",
    });
    const data = await res.json();
    console.log(data);
    this.insurers = data;
  },
};
</script>

<style scoped>
.h2 {
  display: inline;
}
#but {
  display: inline;
  float: right;
}
.clickable-row {
  cursor: pointer;
}
table {
  counter-reset: section;
}
.count:before {
  counter-increment: section;
  content: counter(section);
}
</style>
